import SecuritySection from '../../components/security-section.tsx';
import { AccountSettingsFrame } from './account.tsx';

/**
 * /settings/security: second codes, passkeys, recovery codes and sessions —
 * where a deployment that requires a second factor sends a person who has
 * none yet (app.tsx, login, the social sign-in return). Only this card
 * mounts, so that landing never waits on mailbox or calendar reads.
 */
export default function SecurityPage() {
  return (
    <AccountSettingsFrame current="security" anchorId="settings-security">
      <SecuritySection />
    </AccountSettingsFrame>
  );
}
